/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSmaller } from '../../factoriesAny.js';
export var smallerDependencies = {
  DenseMatrixDependencies: DenseMatrixDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createSmaller: createSmaller
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSmaller.generated.js
// module id = 72
// module chunks = 0